<template>
	<v-dialog v-model="otpModal" persistent max-width="400px">
		<v-card class="px-4 py-2">
			<v-card-title class="px-0">
				<span class="title grey-lighten-1--text">{{heading}}</span>

				<v-btn icon class="top-right-align" @click="closeOtpModal">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="px-0">
				<v-text-field
					label="Enter OTP"
					v-model="otp"
					class="pr-4"
					autofocus
					@keyup.enter="buttonClicked"
				></v-text-field>
				<div class="justify-end mt-3 verCenteredChild">
					<v-btn
						flat
						color="blue lighten-1"
						class="my-0 mx-4"
						@click="sendOTP"
						:loading="sendOTPLoading"
					>
						<v-icon left>refresh</v-icon>Resend OTP
					</v-btn>
					<v-btn
						class="white--text"
						:color="themeInputColor"
						@click="buttonClicked"
						:loading="isLoading"
					>Verify</v-btn>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { SEND_SMS } from "@/store/action-types";

export default {
	name: "OTPModal",
	props: ["otpModal", "heading", "isLoading", "themeInputColor", "amount"],
	data() {
		return {
			otp: null,
			sendOTPLoading: false
		};
	},
	computed: {
		...mapState({
			userId: state => state.auth.USERID,
			username: state => state.auth.USERNAME
		})
	},
	methods: {
		buttonClicked() {
			this.$emit("ACTION_BUTTON_CLICKED", {
				otp: this.otp
			});
		},
		resendClicked() {
			this.$emit("RESEND_BUTTON_CLICKED");
		},
		closeOtpModal() {
			this.otp = null;
			this.$emit("CLOSE_OTP_MODAL");
		},
		sendOTP() {
			const to_send = {
				username: this.username,
				amount: this.amount
			};
			if (!this.sendOTPLoading) {
				this.sendOTPLoading = true;
				this.$store
					.dispatch(SEND_SMS.dispatch, to_send)
					.catch(() => {})
					.then(() => {
						this.sendOTPLoading = false;
						this.otpModal = true;
					});
			}
		}
	},
	watch: {
		otpModal(newVal) {
			if (newVal) {
				this.sendOTP();
			}
		}
	}
};
</script>
